export const getFieldType = (types) => {
  const [type] = Object.entries(types).find(([, condition]) => !!condition);
  return type;
};
